import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix Leaflet marker issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: 'https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.3/dist/images/marker-shadow.png',
});

function LocationMarker({ onLocationSelect }) {
  const [position, setPosition] = useState(null);

  useMapEvents({
    click(e) {
      setPosition(e.latlng);
      onLocationSelect(e.latlng);
    },
  });

  return position ? <Marker position={position} /> : null;
}

// Helper to fetch country from coordinates
async function fetchCountry(lat, lng) {
  const url = `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`;
  const response = await fetch(url, {
    headers: {
      'User-Agent': 'AdLuckApp/1.0 (your@email.com)', // add your email or app info here per OSM policy
    }
  });
  const data = await response.json();
  return data.address?.country || "Country Not Found";
}

export default function LocationPicker({ onSaveLocation }) {
  const [showMap, setShowMap] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState("");

  const handleSave = async () => {
    if (selectedLocation && typeof onSaveLocation === 'function') {
      const country = await fetchCountry(selectedLocation.lat, selectedLocation.lng);
      setSelectedCountry(country);
      onSaveLocation(country); // Pass country name instead of lat/lng
    } else {
      alert("Please select a location by clicking on the map.");
    }
  };

  return (
    <div className="w-full mt-2 rounded-md pb-10">
      {!showMap ? (
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744662507/image_7_cmsog2.png"
          alt="Click to select location"
          className="rounded-md w-full h-auto object-cover mt-4 cursor-pointer"
          onClick={() => setShowMap(true)}
        />
      ) : (
        <>
          <MapContainer
            center={[0, 0]}
            zoom={2}
            style={{ height: "400px", width: "100%" }}
            className="rounded-md mt-4"
          >
            <TileLayer
              attribution='&copy; OpenStreetMap contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <LocationMarker onLocationSelect={setSelectedLocation} />
            {selectedLocation && <Marker position={selectedLocation} />}
          </MapContainer>
          {selectedLocation && (
            <button
              className="bg-[#03897B] text-white font-bold py-2 px-4 rounded hover:bg-[#02695E] mt-4"
              onClick={handleSave}
              type="button"
            >
              Save Location
            </button>
          )}
        </>
      )}
      {selectedCountry && (
        <div className="mt-2 text-green-600 font-bold">
          Selected Country: {selectedCountry}
        </div>
      )}
      <div className=" items-center">
        <p className="text-[#979797] font-light md:text-[24px] text-[8px]">
          Click location on map and save.
        </p>
        <p className="text-black md:text-[32px] md:mt-3 text-[8px] font-normal leading-snug ">
          <span className="text-red-500 ">*</span> We will not share your personal Information without your authorization.
        </p>
      </div>
    </div>
  );
}